import { Box } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const SignatureCompleted = () => {
  const { palette } = useCustomTheme();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gridGap={8} minHeight={450}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor={palette.success.light}
        borderRadius="50%"
        width={120}
        height={120}
        mb={3}
      >
        <Icon size={64} color={palette.success.main}>
          check_circle
        </Icon>
      </Box>
      <Font variant="h3" color="title">
        <Text strong tId={'CONTRACT_SIGNED_SUCCESSFULLY'} />
      </Font>
      <Font variant="subtitle2" align="center" color="textSecondary">
        <Text tId={'CONTRACT_SIGNED_SUCCESSFULLY_DESCRIPTION'} />
      </Font>
    </Box>
  );
};
